// Bridges the bundler-managed React modules into the global `window` namespace
// that the original script-tag-based code expects. Imported FIRST from main.jsx
// so its body executes before any other module body, guaranteeing that
// `React`, `ReactDOM`, hooks, etc. are available as globals when files like
// screens-core.jsx run their top-level `const { useState } = React;` lines.

import * as React from 'react';
import { createRoot } from 'react-dom/client';

if (typeof window !== 'undefined') {
  window.React = React;
  window.ReactDOM = { createRoot };
  // Build identity baked in by vite.config.js (define block). The version
  // watcher in app.jsx compares __APP_BUILD_ID__ against the server's
  // /api/v1/version response and prompts a reload when they diverge.
  // typeof guards keep this file safe to import outside a vite build.
  window.__APP_VERSION__ = typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : 'dev';
  window.__APP_COMMIT__ = typeof __APP_COMMIT__ !== 'undefined' ? __APP_COMMIT__ : 'dev';
  window.__APP_BUILD_ID__ = typeof __APP_BUILD_ID__ !== 'undefined' ? __APP_BUILD_ID__ : 'dev';
}
